import styled from "styled-components";

export const PageResumo = styled.div`
    position: relative;
    display: flex;
    width: 297mm;
    /* min-height: 210mm;
    height: 210mm; */
    align-items: center;
    flex-direction: column;
    border: 1px solid #bbd9cb;
    box-sizing: border-box;
    padding: 20px;
    page-break-before: always;

    h2.PageResumo__title {
        font-weight: 700;
        color: #498564;
    }


    div.PageResumo__table {
        width: 100%;
        margin-top: 15px;
        border: thin solid var(--border-color);
        border-top-left-radius: 5px;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        /* page-break-after: always; */

        div.PageResumo__table__header {
            width: 100%;
            background: #fff;
            border-bottom: thin solid var(--border-color);
            color: var(--text-color);
            display: flex;
            align-items: center;
            box-sizing: border-box;
            overflow: hidden;

            .PageResumo__table__header__title {
                box-sizing: border-box;
                padding: 8px;
                width: 120px;
                background: var(--hover-color);
                border-right: thin solid var(--border-color);
                font-weight: 600;
            }
            .PageResumo__table__header__title.bolder {
                font-weight: 700;
            }
            .PageResumo__table__header__value {
                box-sizing: border-box;
                padding: 8px;
                width: calc(100% - 120px);
                text-transform: capitalize;
                font-weight: 500;
            }
            .PageResumo__table__header__value.bolder {
                font-weight: 600;
            }
        }

        div.PageResumo__table__content {
            width: 100%;
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            padding: 15px;


        }
    }



    div.PageResumo__radape {
        width: 100%;
        display: flex;
        flex-direction: column;
        padding: 15px 0px;
        gap: 10px;
        color: var(--primary-color);
        font-size: 10px;
        page-break-inside: avoid;

        img.PageResumo__radape__logo {
            width: 95px;
        }
    }
`;
